// extracted by mini-css-extract-plugin
export default {"Privacy":"Privacy_Privacy__vylcH"};